import React from 'react';
import SidePanelTab from '../../../components/SidePanelTab';


export default function Leftscreen({ menuIndex, setIsSidePanelVisible, isMobile = false }: { menuIndex: number, setIsSidePanelVisible: (value: boolean) => void, isMobile?: boolean }) {

  return (
    <SidePanelTab setIsSidePanelVisible={setIsSidePanelVisible} menuIndex={menuIndex} isMobile={isMobile} />
  );
}
